import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rawMaterial", "quantity", "total"]
  static values = {
    companyId: String
  }

  connect() {
    if (this.hasRawMaterialTarget && this.hasQuantityTarget && this.hasTotalTarget) {
      this.calculateTotal()
    }
  }

  async calculateTotal() {
    const rawMaterialId = this.rawMaterialTarget.value
    const quantity = parseFloat(this.quantityTarget.value) || 0

    if (rawMaterialId && quantity > 0) {
      try {
        const response = await fetch(`/api/v1/companies/${this.companyIdValue}/raw_materials/${rawMaterialId}`)
        const data = await response.json()
        const price = parseFloat(data.price) || 0
        // Calculate: raw_material * quantity
        const total = price * quantity
        this.totalTarget.value = total.toFixed(2)

        // Trigger an input event on the total field to update bolt production
        const event = new Event('input', { bubbles: true })
        this.totalTarget.dispatchEvent(event)
      } catch (error) {
        console.error("Error fetching raw material price:", error)
      }
    } else {
      this.totalTarget.value = "0.00"
      // Also trigger when setting to zero
      const event = new Event('input', { bubbles: true })
      this.totalTarget.dispatchEvent(event)
    }
  }

  rawMaterialChange() {
    this.calculateTotal()
  }

  quantityChange() {
    this.calculateTotal()
  }
}
